export default {
  getToken: state => state.token,
  getAccount: state => state.account
}
